


































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { AdminCMSRoleModule } from '@/app/store/modules/adminCMSRole'

@Component({
  name: 'AdminCMS',
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  public searchInput = ''
  private selected = []
  public created() {
    AdminCMSRoleModule.paginationParam.search = ''
    this.getRoleCMSData()
  }

  public getRoleCMSData() {
    AdminCMSRoleModule.getRoleCMSData()
  }

  public get AdminRoleCMSData() {
    return AdminCMSRoleModule.AdminRoleCMSData
  }

  public get isLoading() {
    return AdminCMSRoleModule.isLoading
  }

  public get page() {
    return AdminCMSRoleModule.Pages
  }

  public get limit() {
    return AdminCMSRoleModule.Limit
  }

  public get fields() {
    return AdminCMSRoleModule.fields
  }

  private onPageNumChanged(limit: any) {
    AdminCMSRoleModule.paginationParam.paging.limit = limit
    this.getRoleCMSData()
  }

  private funcFirstPage() {
    AdminCMSRoleModule.paginationParam.paging.page =
      AdminCMSRoleModule.paginationParam.paging.page - 1
    this.getRoleCMSData()
  }

  private funcPrevPage() {
    AdminCMSRoleModule.paginationParam.paging.page =
      AdminCMSRoleModule.paginationParam.paging.page - 1
    this.getRoleCMSData()
  }

  private funcNextPage() {
    AdminCMSRoleModule.paginationParam.paging.page =
      AdminCMSRoleModule.paginationParam.paging.page + 1
    this.getRoleCMSData()
  }

  private funcLastPage() {
    AdminCMSRoleModule.paginationParam.paging.page =
      (this.AdminRoleCMSData.pagination &&
        this.AdminRoleCMSData.pagination.pageCount) ||
      0
    this.getRoleCMSData()
  }

  private onRowSelected(items) {
    this.selected = items
  }

  private funcSearch(item) {
    AdminCMSRoleModule.paginationParam.search = item
    this.getRoleCMSData()
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
